"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterMap = {
  tipo_trabajo: {
    'full-time': 'full-time',
    'part-time': 'part-time',
    pasantia: 'pasantia',
    'por-horas': 'por-horas',
    temporario: 'temporario',
    'por-contrato': 'por-contrato',
    teletrabajo: 'teletrabajo',
    'primer-empleo': 'primer-empleo',
    'fines-de-semana': 'fines-de-semana',
    voluntario: 'voluntario',
    nocturno: 'nocturno'
  }
};
exports.tagsTranslationMap = {
  toPath: {
    area: 'area',
    subarea: 'subarea',
    tipo_trabajo: 'tipo-trabajo',
    apto_discapacitado: 'discapacitados',
    distancia: 'distancia',
    salario: 'salario',
    nivel_laboral: 'seniority',
    dias_fecha_publicacion: 'publicacion',
    provincia: 'provincia',
    localidad: 'localidad',
    busqueda: 'busqueda',
    modalidad_trabajo: 'modalidad'
  },
  toBFFId: {
    area: 'area',
    subarea: 'subarea',
    'tipo-trabajo': 'tipo_trabajo',
    discapacitados: 'apto_discapacitado',
    distancia: 'distancia',
    salario: 'salario',
    seniority: 'nivel_laboral',
    publicacion: 'dias_fecha_publicacion',
    provincia: 'provincia',
    localidad: 'localidad',
    busqueda: 'busqueda',
    modalidad: 'modalidad_trabajo'
  }
};